const Container = ({ children }) => {
  return <div className="bg-gray-100 min-h-screen p-4 sm:p-6">{children}</div>;
};

export default Container;
